import { Modal } from '@mui/material';
import { useState } from 'react';
import { Icon } from '@iconify/react';
import {
    CloseButton,
    DividerTitulationModal,
    RowAlert,
    WrapperModal,
} from '../../../../styled-components';
import { Text } from '../../../common/Texts';
import InputPDFDocument from './InputPDFDocument';
import DenyMessage from './DenyMessage';

const IaUploadDocumentsModal = (props) => {
    const {
        open,
        handleCloseModal,
        title,
        handleSave,
        documentType,
        denyMessage,
    } = props;

    // States
    const [file, setFile] = useState(null);
    const [step, setStep] = useState(denyMessage ? 0 : 1);

    const handleSaveFile = () => {
        if (!!file) {
            handleSave(file);
            handleCloseModal(true);
        }
    };
    return (
        <Modal onClose={handleCloseModal} open={open}>
            <WrapperModal
                widthModal="550px"
                maxHeightModal="80vh"
                gapModal="1rem"
                topModal="50%"
                leftModal="50%"
            >
                <CloseButton onClick={handleCloseModal}>
                    <Icon icon="iconoir:cancel" width="24px" height="24px" />
                </CloseButton>

                {step === 0 && denyMessage && (
                    <DenyMessage
                        message={denyMessage}
                        handleStep={() => {
                            setStep(1);
                        }}
                    />
                )}

                {step === 1 ? (
                    <>
                        <Text
                            fontSize="20px"
                            fontWeight={700}
                            color="#B31D15"
                            textAlign="left"
                            lineHeight="24px"
                        >
                            Subir documentación: {title}
                        </Text>
                        <DividerTitulationModal />
                        <RowAlert>
                            <Icon
                                icon="pepicons-pencil:exclamation-circle"
                                width="24"
                                height="24"
                            />
                            <Text
                                fontSize="16px"
                                fontWeight={700}
                                color="#B31D15"
                                textAlign="left"
                                fontStyle="italic"
                                lineHeight="25px"
                            >
                                Recuerda que sólo puedes subir el documento en
                                formato PDF o imagen.
                            </Text>
                        </RowAlert>
                        <InputPDFDocument
                            file={file}
                            setFile={setFile}
                            handlePreviousStep={handleCloseModal}
                            handleNextStep={handleSaveFile}
                            documentType={documentType}
                        />
                    </>
                ) : null}
            </WrapperModal>
        </Modal>
    );
};

export default IaUploadDocumentsModal;
